// extracted by css-extract-rspack-plugin
export default {"campaign":"campaign-lzKY8G"};